import React from 'react';

import {setURLParams} from 'BenchlingUtil';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ClientId, NLOId} from 'notebook/ELNConstants';
import noteLinkedEmbeddingPlugin from 'notebook/embeddings/NoteLinkedEmbeddingPlugin';
import NoteLinkedChartView from 'notebook/integrations/charts/NoteLinkedChartView';
import {NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';

export type GenericNoteLinkedChart<TIds> = {
  name: string;
  type: NoteLinkedObjectType.NOTE_LINKED_CHART;
  chart: {id: string};
  provenance: {url: string; type?: string};
} & NLOId<TIds>;
export type NoteLinkedChart = GenericNoteLinkedChart<ClientId>;
export type ChartNotePart = NotePart & {item: NoteLinkedChart};

function shouldShowAnalysisProvenance(notePart: ChartNotePart): boolean {
  // This is for backcompat, but charts didn't use to have a type field, so we just assume they're analysis in that case.
  return (
    Boolean(notePart.item.provenance?.url) &&
    (notePart.item.provenance.type === undefined || notePart.item.provenance.type === 'analysis')
  );
}

const NOTE_LINKED_CHART_PLUGIN = noteLinkedEmbeddingPlugin<ChartNotePart>({
  type: ModelTypeConstants.NOTE_LINKED_CHART,
  title: 'Chart',
  icon: 'line-chart',
  getContentId: (notePart: ChartNotePart) => notePart.item.chart.id,
  getEmbedding: (notePart: ChartNotePart) => <NoteLinkedChartView chartId={notePart.item.chart.id} />,
  getName: (notePart: ChartNotePart) => notePart.item.name,
  getNameUpdate: (notePart: ChartNotePart, name: string) => ({name}),
  getProvenance: (notePart: ChartNotePart) =>
    shouldShowAnalysisProvenance(notePart)
      ? {
          url: setURLParams(notePart.item.provenance.url, {
            screen: 'view',
            chartId: notePart.item.chart.id,
          }),
          type: 'Analysis',
          icon: 'analytics_analysis',
        }
      : undefined,
});

export default NOTE_LINKED_CHART_PLUGIN;
